/* ── WhatsApp helpers ────────────────────────────────────────────────── */

import { stickerCode } from '../albumData';

// Build a wa.me deep link. Works on desktop (opens web/desktop app) and on
// mobile (opens the native app if installed). Returns null if phone is empty.
export function buildWhatsappLink(rawPhone, message) {
  if (!rawPhone) return null;
  const digits = String(rawPhone).replace(/[^\d]/g, '');
  if (!digits) return null;
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${digits}${text}`;
}

// Build a mailto: deep link. Returns null if email is empty.
export function buildMailtoLink(email, subject, body) {
  if (!email) return null;
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  const query = params.length ? `?${params.join('&')}` : '';
  return `mailto:${email}${query}`;
}

// Best-effort pretty format for AR / generic E.164 numbers. We don't lock to a
// country code — if it doesn't match a known shape we return the digits with a
// leading '+'. Examples: +5491134567890 → "+54 9 11 3456-7890".
export function formatPhoneDisplay(rawPhone) {
  if (!rawPhone) return '';
  const digits = String(rawPhone).replace(/[^\d]/g, '');
  if (!digits) return '';
  // AR mobile: 54 9 XX XXXX-XXXX (10 nat digits + "9")
  if (digits.startsWith('549') && digits.length === 13) {
    const area = digits.slice(3, 5);
    const a = digits.slice(5, 9);
    const b = digits.slice(9, 13);
    return `+54 9 ${area} ${a}-${b}`;
  }
  if (digits.startsWith('54') && digits.length === 12) {
    const area = digits.slice(2, 4);
    const a = digits.slice(4, 8);
    const b = digits.slice(8, 12);
    return `+54 ${area} ${a}-${b}`;
  }
  return `+${digits}`;
}

// Build the pre-armed trade message in the active locale. `t` is the i18next
// translator; placeholders `{{name}}`, `{{me}}`, `{{give}}`, `{{get}}` get
// filled in.
export function buildTradeMessage(t, { theirName, myName, giveNums, getNums }) {
  const fmt = (nums) => (nums || []).map(n => stickerCode(n)).join(', ') || '—';
  return t('wa_trade_message', {
    name: theirName || '',
    me: myName || '',
    give: fmt(giveNums),
    get: fmt(getNums),
  });
}
